import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { WorkflowFile } from 'app/models/workflow-file';
import { FormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalDirective, MdbCheckboxChange } from 'ng-uikit-pro-standard';
import { WorkflowForm } from 'app/models/workflow-form';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { UserService } from 'app/services/user.service';
import { TeamService } from 'app/services/team.service';
import { ContactService } from 'app/services/contactService';

@Component({
  selector: 'app-add-email-rule',
  templateUrl: './add-email-rule.component.html',
  styleUrls: ['./add-email-rule.component.scss']
})
export class AddEmailRuleComponent implements OnInit {
  
  @Output() addEditAccepted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @Input() workflowForms: WorkflowForm[];
  @Input() workflowFiles: WorkflowFile[];
  @Input() isEdit: boolean;

  autoEmailRuleToAddFormGroup: FormGroup;

  @Input() withTargets: boolean = true;
  @Input() forExecution: boolean = false;

  isBodyError: string;
  isSubjectError: string;
  isToError: string;
  isFromError: string;
  
  emailFromRadioModel: string;

  AccordionActiveTab: string = 'from';

  @ViewChild('selectAllFormsComponent', { static: false }) selectAllFormsComponent: NgSelectComponent;
  @ViewChild('selectAllFilesComponent', { static: false }) selectAllFilesComponent: NgSelectComponent;
  @ViewChild('addEditAutoEmailModal', { static: true }) addEditAutoEmailModal: ModalDirective;

  constructor(public userService: UserService, public teamService: TeamService, public contactService: ContactService, private validationHandler: ValidationHandler) {}
 
  ngOnInit() {
    this.isFromError = this.isToError = this.isSubjectError = this.isBodyError = undefined;
    this.AccordionActiveTab = 'from';
  }

  show(frm: FormGroup) {
    this.ngOnInit();

    this.autoEmailRuleToAddFormGroup = frm;
    
    if (this.autoEmailRuleToAddFormGroup.value.is_from_initiator) {
      this.emailFromRadioModel = 'from_initiator';
    } else if (this.autoEmailRuleToAddFormGroup.value.from_user) {
      this.emailFromRadioModel = 'from_user';
    } else if (this.autoEmailRuleToAddFormGroup.value.from_custom && this.autoEmailRuleToAddFormGroup.value.from_custom != '') {
      this.emailFromRadioModel = 'from_custom';
    }
    this.addEditAutoEmailModal.show();
  }

  onOpened() {
    this.selectAllFormsComponent.setDisabledState(this.autoEmailRuleToAddFormGroup.value.is_all_forms == true);
    this.selectAllFilesComponent.setDisabledState(this.autoEmailRuleToAddFormGroup.value.is_all_files == true);
  }

  onAddAutoUploadModalAddClick() {
    this.validationHandler.onSubmitCheck(this.autoEmailRuleToAddFormGroup);
    if(!this.autoEmailRuleToAddFormGroup.valid) {
      return;
    }

    this.addEditAccepted.emit(this.autoEmailRuleToAddFormGroup);
    this.addEditAutoEmailModal.hide();
  }

  onAllFilesChange(e: MdbCheckboxChange) {
    this.selectAllFilesComponent.setDisabledState(e.checked);

    if (e.checked) {
      this.autoEmailRuleToAddFormGroup.get('files').reset();
    }
  }
  
  onAllFormsChange(e: MdbCheckboxChange) {
    this.selectAllFormsComponent.setDisabledState(e.checked);
    if (e.checked) {
      this.autoEmailRuleToAddFormGroup.get('forms').reset();
    }
  }

  onFromRadioChange(e: any) {
    if (this.emailFromRadioModel == 'from_initiator') {
      this.autoEmailRuleToAddFormGroup.get('is_from_initiator').setValue(1); 
      this.autoEmailRuleToAddFormGroup.get('from_custom').setValue(''); 
      this.autoEmailRuleToAddFormGroup.get('from_user').reset();        
    } else if (this.emailFromRadioModel == 'from_user') {
      this.autoEmailRuleToAddFormGroup.get('is_from_initiator').setValue(0); 
      this.autoEmailRuleToAddFormGroup.get('from_custom').setValue(''); 
    } else if (this.emailFromRadioModel == 'from_custom') {
      this.autoEmailRuleToAddFormGroup.get('is_from_initiator').setValue(0); 
      this.autoEmailRuleToAddFormGroup.get('from_user').reset();        
    }
  }

  activeTab(tabName: string){
    if(tabName === this.AccordionActiveTab){
      this.AccordionActiveTab = '';
      return;
    }
    this.AccordionActiveTab = tabName;

  }

}
